import React, { useState } from 'react';
import { EnrichmentSectionBody } from './renderers/index';
import { sectionLabel, statusClass } from './sectionMeta';

function EnrichmentSectionCard({ sectionKey, detectedType, section }) {
  const [showJson, setShowJson] = useState(false);
  const status = section?.status || 'unknown';
  const payload = section?.data ?? section;

  return (
    <section className="enrichment-section card">
      <header className="enrichment-section-header">
        <div>
          <h3 className="enrichment-section-title">{sectionLabel(sectionKey)}</h3>
          <p className="enrichment-section-key">{sectionKey}</p>
        </div>
        <span className={`enrichment-status-pill ${statusClass(status)}`}>{status}</span>
      </header>

      <div className="enrichment-section-body">
        <EnrichmentSectionBody
          sectionKey={sectionKey}
          detectedType={detectedType}
          section={section}
        />
      </div>

      <footer className="enrichment-section-footer">
        <button
          type="button"
          className="enrichment-json-toggle"
          onClick={() => setShowJson((open) => !open)}
        >
          {showJson ? 'Hide JSON' : 'View JSON'}
        </button>
        {showJson && (
          <pre className="entity-raw-json enrichment-section-json">
            {JSON.stringify(payload, null, 2)}
          </pre>
        )}
      </footer>
    </section>
  );
}

export default EnrichmentSectionCard;
